var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    attrs: {
      "id": "searchArea"
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.dataForm
    },
    nativeOn: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDataList(1);
      }
    }
  }, [_c('div', {
    staticClass: "pb16"
  }, [_vm.isAuth('sys:client:save') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.addOrUpdateHandle();
      }
    }
  }, [_vm._v("Add Client code")]) : _vm._e()], 1), _c('div', [_c('el-form-item', [_c('el-input', {
    staticClass: "wd500 input-with-select-lg",
    attrs: {
      "placeholder": _vm.kwPlaceHolder,
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "keyword", $$v);
      },
      expression: "dataForm.keyword"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "prepend",
      "placeholder": "please select"
    },
    slot: "prepend",
    model: {
      value: _vm.dataForm.kwType,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "kwType", $$v);
      },
      expression: "dataForm.kwType"
    }
  }, _vm._l(_vm.kwTypes, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-form-item', [_c('client-code-select-remote-search', {
    attrs: {
      "placeholder": "Client Code"
    },
    model: {
      value: _vm.dataForm.clientCode,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "clientCode", $$v);
      },
      expression: "dataForm.clientCode"
    }
  })], 1), _c('el-form-item', [_c('uen-select-remote-search', {
    attrs: {
      "placeholder": "UEN"
    },
    model: {
      value: _vm.dataForm.uen,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "uen", $$v);
      },
      expression: "dataForm.uen"
    }
  })], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Country"
    },
    model: {
      value: _vm.dataForm.country,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "country", $$v);
      },
      expression: "dataForm.country"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Billing Country"
    },
    model: {
      value: _vm.dataForm.billingCountry,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "billingCountry", $$v);
      },
      expression: "dataForm.billingCountry"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "select coordinator",
      "filterable": "",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.coordinatorIds,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "coordinatorIds", $$v);
      },
      expression: "dataForm.coordinatorIds"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Unassigned",
      "value": "unassigned"
    }
  }), _vm._l(_vm.userList, function (item) {
    return _c('el-option', {
      key: "client-option-".concat(item.id),
      attrs: {
        "label": item.nickname || item.username,
        "value": item.id
      }
    });
  })], 2)], 1), _c('el-form-item', [_c('el-date-picker-range', {
    attrs: {
      "startDate": _vm.dataForm.createTimeStart,
      "endDate": _vm.dataForm.createTimeEnd,
      "startPlaceholder": "Create (Start Date)",
      "endPlaceholder": "Create (End Date)"
    },
    on: {
      "startSelectChange": function startSelectChange(val) {
        _vm.dataForm.createTimeStart = val;
      },
      "endSelectChange": function endSelectChange(val) {
        _vm.dataForm.createTimeEnd = val;
      }
    }
  })], 1), _c('el-form-item', [_c('el-date-picker-range', {
    attrs: {
      "startDate": _vm.dataForm.passTimeStart,
      "endDate": _vm.dataForm.passTimeEnd,
      "startPlaceholder": "Pass (Start Date)",
      "endPlaceholder": "Pass (End Date)"
    },
    on: {
      "startSelectChange": function startSelectChange(val) {
        _vm.dataForm.passTimeStart = val;
      },
      "endSelectChange": function endSelectChange(val) {
        _vm.dataForm.passTimeEnd = val;
      }
    }
  })], 1), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticClass: "controlLeft",
    attrs: {
      "clearable": "",
      "placeholder": "Introduced By"
    },
    on: {
      "change": _vm.introducedByChange
    },
    model: {
      value: _vm.dataForm.introducedBy,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "introducedBy", $$v);
      },
      expression: "dataForm.introducedBy"
    }
  }, _vm._l(_vm.introducedByList, function (item) {
    return _c('el-option', {
      key: item.title,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _vm.dataForm.introducedBy ? _c('el-form-item', {
    staticClass: "fml10"
  }, [_c('el-select-all', {
    staticClass: "controlRight",
    attrs: {
      "width": 220,
      "optionList": _vm.commissionRequiredArr,
      "placeholder": "Commission"
    },
    on: {
      "elSelectAllChange": function elSelectAllChange(list) {
        _vm.dataForm.commission = list;
      }
    }
  })], 1) : _vm._e()], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "Status"
    },
    model: {
      value: _vm.dataForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "status", $$v);
      },
      expression: "dataForm.status"
    }
  }, _vm._l(_vm.clientCodeStatusList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "Marketing Tags"
    },
    model: {
      value: _vm.dataForm.tagIds,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "tagIds", $$v);
      },
      expression: "dataForm.tagIds"
    }
  }, _vm._l(_vm.tagInfoList, function (item) {
    return _c('el-option', {
      key: "Tags-".concat(item.id),
      attrs: {
        "label": item.tagName,
        "value": item.id
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "debounce",
      rawName: "v-debounce"
    }],
    attrs: {
      "icon": "el-icon-search",
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function click($event) {
        return _vm.getDataList(1);
      }
    }
  }, [_vm._v("Search")])], 1)], 1)])], 1), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.dataListLoading,
      expression: "dataListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "max-height": "640",
      "data": _vm.dataList,
      "default-sort": {
        prop: 'createTime',
        order: 'descending'
      }
    },
    on: {
      "sort-change": _vm.tableSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "clientCode",
      "align": "center",
      "label": "Client Code",
      "width": "125",
      "fixed": "left",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', {
          staticClass: "lh20 mt0 mb0"
        }, [_vm._v(_vm._s(scope.row.clientCode))]), _c('el-link', {
          attrs: {
            "type": "primary",
            "underline": false
          },
          on: {
            "click": function click($event) {
              return _vm.openLinkedApplymentyModal(scope.row);
            }
          }
        }, [_vm._v("(Track)")])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "uen",
      "align": "center",
      "label": "UEN",
      "min-width": "120",
      "fixed": "left"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "country",
      "align": "center",
      "label": "Country",
      "min-width": "120",
      "fixed": "left"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "companyName",
      "align": "center",
      "label": "Company Name",
      "min-width": "200",
      "fixed": "left"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "coordinatorList",
      "align": "center",
      "label": "Coordinator",
      "width": "200",
      "fixed": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.coordinatorList ? _c('span', [_vm._v(_vm._s(scope.row.coordinatorList.map(function (item) {
          return item.nickname || item.username;
        }).join(", ")))]) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "align": "center",
      "label": "Create Time",
      "min-width": "130",
      "sortable": "custom"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "passTime",
      "align": "center",
      "label": "Pass Time",
      "min-width": "120",
      "sortable": "custom"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "rejectTime",
      "align": "center",
      "label": "Failed Time",
      "min-width": "130",
      "sortable": "custom"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "inactiveTime",
      "align": "center",
      "label": "Inactive Time",
      "min-width": "140",
      "sortable": "custom"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "introducer",
      "align": "center",
      "label": "Introducer",
      "min-width": "100"
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Introduced By",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.introducedByFormat(scope.row.introducedBy)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Commission",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return _vm._l(scope.row.commissionList, function (item) {
          return _c('p', {
            key: "commission-".concat(scope.row.id, "-").concat(item.id),
            staticClass: "mt0 mb0"
          }, [_vm._v(" " + _vm._s(item.name) + " - " + _vm._s(_vm.multiply(item.commissionRate)) + " "), item.remark ? _c('el-popover', {
            attrs: {
              "placement": "bottom",
              "trigger": "hover"
            }
          }, [_c('div', {
            staticClass: "fs12 lh20 enbr",
            staticStyle: {
              "max-width": "300px"
            }
          }, [_vm._v(_vm._s(item.remark))]), _c('span', {
            staticClass: "fs14 lightGray el-icon-info",
            attrs: {
              "slot": "reference"
            },
            slot: "reference"
          })]) : _vm._e()], 1);
        });
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "relationshipRemark",
      "align": "center",
      "label": "Relationship",
      "min-width": "260"
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Billing Addresses",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$billingInf;

        return [((_scope$row$billingInf = scope.row.billingInfoList) === null || _scope$row$billingInf === void 0 ? void 0 : _scope$row$billingInf.length) > 0 ? _c('div', _vm._l(scope.row.billingInfoList, function (item, index) {
          return _c('p', {
            key: "billing-".concat(scope.row.id, "-").concat(index)
          }, [_c('span', {
            staticClass: "mr4"
          }, [_vm._v(_vm._s(item.billingAddress))]), _c('el-popover', {
            attrs: {
              "placement": "bottom",
              "trigger": "hover"
            }
          }, [_c('div', {
            staticClass: "fs12 lh20 enbr",
            staticStyle: {
              "max-width": "300px"
            }
          }, [_c('div', [_vm._v("Country: " + _vm._s(item.billingCountry))]), _c('div', [_vm._v("Zone: " + _vm._s(item.billingZone))]), _c('div', [_vm._v("Postal/ZIP Code: " + _vm._s(item.billingPostalCode))])]), _c('span', {
            staticClass: "fs14 lightGray el-icon-info",
            attrs: {
              "slot": "reference"
            },
            slot: "reference"
          })])], 1);
        }), 0) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "attention",
      "align": "center",
      "label": "Attention",
      "min-width": "250"
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Contact Persons",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$contactInf;

        return [((_scope$row$contactInf = scope.row.contactInfoList) === null || _scope$row$contactInf === void 0 ? void 0 : _scope$row$contactInf.length) > 0 ? _c('div', _vm._l(scope.row.contactInfoList, function (item, index) {
          var _item$tagList, _item$tagList$map;

          return _c('p', {
            key: "contact-".concat(scope.row.id, "-").concat(index)
          }, [_c('span', {
            staticClass: "mr4"
          }, [_vm._v(_vm._s(item.contactName))]), _c('el-popover', {
            attrs: {
              "placement": "bottom",
              "trigger": "hover"
            }
          }, [_c('div', {
            staticClass: "fs12 lh20 enbr",
            staticStyle: {
              "max-width": "300px"
            }
          }, [_c('div', [_vm._v("Email: " + _vm._s(item.contactEmail))]), _c('div', [_vm._v("Receive Marketing Emails: " + _vm._s(item.isReceiveEmail ? "Yes" : "No"))]), _c('div', [_vm._v("Tags: " + _vm._s((item === null || item === void 0 ? void 0 : (_item$tagList = item.tagList) === null || _item$tagList === void 0 ? void 0 : (_item$tagList$map = _item$tagList.map(function (i) {
            return i.tagName;
          })) === null || _item$tagList$map === void 0 ? void 0 : _item$tagList$map.join(", ")) || ""))]), _c('div', [_vm._v("Position & Other information: " + _vm._s(item.contactPosition))])]), _c('span', {
            staticClass: "fs14 lightGray el-icon-info",
            attrs: {
              "slot": "reference"
            },
            slot: "reference"
          })])], 1);
        }), 0) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "align": "center",
      "label": "Description",
      "min-width": "260"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "align": "center",
      "label": "Status",
      "min-width": "126"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', {
          staticClass: "lh20 mt0 mb0"
        }, [_vm._v(_vm._s(_vm.clientCodeStatusFormat(scope.row.status)))]), _c('el-link', {
          attrs: {
            "type": "primary",
            "underline": false
          },
          on: {
            "click": function click($event) {
              return _vm.openStatusHistoryModal(scope.row.id);
            }
          }
        }, [_vm._v("(Track)")])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Marketing Tags",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$tagList, _scope$row$tagList$ma;

        return [((_scope$row$tagList = scope.row.tagList) === null || _scope$row$tagList === void 0 ? void 0 : _scope$row$tagList.length) > 0 ? _c('p', [_vm._v(_vm._s((_scope$row$tagList$ma = scope.row.tagList.map(function (i) {
          return i.tagName;
        })) === null || _scope$row$tagList$ma === void 0 ? void 0 : _scope$row$tagList$ma.join(", ")))]) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "120",
      "fixed": "right",
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm.isAuth('sys:client:update') && (scope.row.status == 0 || scope.row.status == 2) ? _c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.addOrUpdateHandle(scope.row);
            }
          }
        }, [_vm._v(" Edit ")]) : _vm._e(), _vm.isAuth('sys:client:updateBaseInfo') && scope.row.status != 0 && scope.row.status != 2 ? _c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.updateBaseHandle(scope.row);
            }
          }
        }, [_vm._v(" Quick Edit ")]) : _vm._e(), _vm.isAuth('sys:client:audit') && (scope.row.status == 0 || scope.row.status == 2) ? _c('el-button', {
          staticClass: "fwb ml0",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.reviewHandle(scope.row);
            }
          }
        }, [_vm._v(" Review ")]) : _vm._e(), _vm.isAuth('sys:client:delete') ? _c('el-button', {
          staticClass: "fwb ml0",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteHandle(scope.row);
            }
          }
        }, [_vm._v("Delete")]) : _vm._e(), _vm.isAuth('sys:client:revise') && scope.row.status == 1 ? _c('el-button', {
          staticClass: "fwb ml0",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.statusUpdateHandle(scope.row, 0, 'Revise');
            }
          }
        }, [_vm._v(" Revise ")]) : _vm._e(), _vm.isAuth('sys:client:inactive') && scope.row.status != 3 ? _c('el-button', {
          staticClass: "fwb ml0",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.statusUpdateHandle(scope.row, 3, 'Inactive');
            }
          }
        }, [_vm._v(" Inactive ")]) : _vm._e(), _vm.isAuth('sys:client:reActive') && scope.row.status == 3 ? _c('el-button', {
          staticClass: "fwb ml0",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.statusUpdateHandle(scope.row, 0, 'Re-active');
            }
          }
        }, [_vm._v(" Re-active ")]) : _vm._e()];
      }
    }])
  })], 1)], 1), _c('pagination', {
    attrs: {
      "current": _vm.current,
      "pageSize": _vm.pageSize,
      "totalCount": _vm.totalCount
    },
    on: {
      "size-change": _vm.sizeChangeHandle,
      "current-change": _vm.currentChangeHandle
    }
  }), _c('add-or-update', {
    ref: "addOrUpdate",
    attrs: {
      "userList": _vm.userList,
      "tagInfoList": _vm.tagInfoList,
      "commissionRequiredList": _vm.commissionRequiredList
    },
    on: {
      "refreshDataList": _vm.getDataList
    }
  }), _c('update-base-info', {
    ref: "updateBaseInfoModal",
    attrs: {
      "userList": _vm.userList,
      "tagInfoList": _vm.tagInfoList,
      "commissionRequiredList": _vm.commissionRequiredList
    },
    on: {
      "refreshDataList": _vm.getDataList
    }
  }), _c('linked-applymenty', {
    ref: "linkedApplymentyModal"
  }), _c('status-history', {
    ref: "statusHistoryModal"
  }), _c('client-review', {
    ref: "clientReviewModal",
    on: {
      "refreshStatus": _vm.getDataList
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }